import axios from "axios";
import { toast } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import Env from "../constant/env.json";

const useHttp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  var token = localStorage.getItem("token");

  const httpService = axios.create({
    baseURL: Env.base_url,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  httpService.interceptors.response.use(
    (response) => response,
    async ({ error, response }) => {
      console.log("HttpService error", error);
      console.log("HttpService response", JSON.stringify(response, null, 2));
      if (response.status === 401) {
        if (location.pathname == "/login") {
          toast.error(response.data.message);
        } else {
          localStorage.removeItem("token");
          navigate("/");
          toast.error("You have been logged out.");
        }
      } else if (response?.data?.errors) {
        if (response?.data?.errors) {
          toast.error(response?.data?.errors[0].detail);
        }
      } else if (response.data.message) {
        toast.error(response?.data?.message);
      } else if (response.status === 404) {
        toast.error("Not Found!");
      } else {
        toast.error("Server Error!");
      }
    }
  );

  const exports = { httpService };

  return exports;
};

export default useHttp;
